<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-12">
        <router-link
          to="/principal/orders/add"
          class="btn btn-success col-lg-2"
          v-if="$can('create', 'Enterprise')"
        >Agregar Pedido</router-link>
        <b-button type="submit" v-if="nameMarca !== 'Pedidos General'" class="ml-1 btn col-lg-2" variant="primary" @click="confirmationDialog('buy')">Cargar compra</b-button>
        <b-button type="submit" class="ml-1 btn col-lg-2" variant="info" @click="confirmationDialog('save')">Guardar (Depurar)</b-button>
        <b-button type="submit" class="ml-1 btn col-lg-2" variant="dark" @click="agregarFaltante()">Faltante</b-button>
        <b-button type="submit" class="ml-1 btn col-lg-2" variant="danger" @click="deleteOrder()">Eliminar</b-button>
      </div>
    </div>
    <div class="col-lg-12 text-center mt-5 mb-2">
      <span><h2><b>{{nameMarca}}</b></h2></span>
    </div>
    <template>
      <b-card class="mt-2">
        <b-tabs v-model="tabIndex" @input="onTabChange">
          <b-tab
            v-for="(rowData, index) in jsondata"
            :key="index"
            :title="jsondata[index].dates"
            :title-link-class="linkClass(index)"
            active-nav-item-class="font-weight-bold text-uppercase text-danger"
            active-tab-class="font-weight-bold text-success"
          >
            <button @click="exportAsExcel('redrogo' + index)"> Export Excel </button>
            <button @click="exportAsCsv('redrogo' + index)"> Export CSV </button>
            <h5 class="text-center">{{jsondata[index].group}}</h5>
            <vue-excel-editor
              :ref="'redrogo' + index"
              :cell-style='mystyle'
              v-model="jsondata[index].orders"
              no-paging
              filter-row
              autocomplete>
                <vue-excel-column field="fullnameUser"          label="Usuario"        textTransform="uppercase" readonly/>
                <vue-excel-column field="id_client"     label="# Cliente"     width="80px" />
                <vue-excel-column field="fullname"      label="Cliente"        width="150px" />
                <vue-excel-column field="catalogo"      label="Catalogo"       width="120px" />
                <vue-excel-column field="pagina"        label="Pagina"         width="60px"  type="number"/>
                <vue-excel-column field="comentario"    label="Comentario"     width="120px" />
                <vue-excel-column field="campo_muerto"  label="Texto abierto"  width="120px" />
                <vue-excel-column field="marca"         label="Marca"          width="100px" />
                <vue-excel-column field="modelo"        label="Modelo"         width="100px" />
                <vue-excel-column field="color"         label="Color"          width="80px"  />
                <vue-excel-column field="numero"        label="Talla"          width="70px"  />
                <vue-excel-column field="providerName"  label="Empresa"        width="150px" type="select" :options="optionsEnterprise" :change="changeEnterprise" />
                <vue-excel-column field="delivery_date" label="Fecha"          width="150px" />
            </vue-excel-editor>
          </b-tab>
        </b-tabs>
      </b-card>
    </template>
  </div>
</template>

<script>
import axiosAdelaService from '@/axios/axiosAdelaService'
import formatData from '@/mixins/formatAxios'
import { BButton, BTabs, BTab, BCard } from 'bootstrap-vue'
import moment from 'moment'
import { mapGetters } from 'vuex'
moment.locale('es')

export default {
  props: ['marca'],
  mixins: [formatData],
  components: {
    BButton,
    BTabs,
    BTab,
    BCard
  },
  data () {
    return {
      tabIndex: 0,
      nameMarca: '',
      rows: [],
      isLoading: false,
      id_provider: 0,
      jsondata: [],
      optionsMarca: [],
      optionsEnterprise: [],
      columnWidths: {}
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  methods: {
    // ─── Tab change ───────────────────────────────────────────────
    onTabChange (index) {
      this.$nextTick(() => {
        this.attachResizeListener(index)
        this.restoreColumnWidths(index)
      })
    },

    // ─── Intercepta colSepMouseUp y colSepMouseMove ───────────────
    attachResizeListener (index) {
      const ref = this.$refs['redrogo' + index]
      if (!ref || !ref[0]) return
      const editorEl = ref[0].$el
      if (!editorEl) return
      if (editorEl._resizeListenerAttached) return
      editorEl._resizeListenerAttached = true

      const originalColSepMouseUp = ref[0].colSepMouseUp.bind(ref[0])
      ref[0].colSepMouseUp = (...args) => {
        originalColSepMouseUp(...args)

        this.$nextTick(() => {
          // Leer anchos reales del DOM
          const headers = ref[0].$el.querySelectorAll('thead tr th')
          // Saltar el primer th (checkbox/settings)
          const dataHeaders = Array.from(headers).slice(1)

          this.columnWidths[index] = ref[0].$data.fields.map((field, i) => ({
            name: field.name,
            width: dataHeaders[i] ? (dataHeaders[i].style.width || dataHeaders[i].offsetWidth + 'px') : field.width
          }))
          console.log('✅ Anchos guardados (DOM + fields):', this.columnWidths[index])
          this.restoreColumnWidths(index)
        })
      }

      const originalColSepMouseMove = ref[0].colSepMouseMove.bind(ref[0])
      ref[0].colSepMouseMove = (...args) => {
        originalColSepMouseMove(...args)
      }
    },
    _captureWidthsFromData (componentRef, index) {
      if (!componentRef.$data.fields) return
      this.columnWidths[index] = componentRef.$data.fields.map(field => ({
        name: field.name,
        width: field.width
      }))
    },

    restoreColumnWidths (index) {
      if (!this.columnWidths[index] || !this.columnWidths[index].length) return
      setTimeout(() => {
        const ref = this.$refs['redrogo' + index]
        if (!ref || !ref[0] || !ref[0].$data.fields) return

        this.columnWidths[index].forEach(saved => {
          const fieldIndex = ref[0].$data.fields.findIndex(f => f.name === saved.name)
          if (fieldIndex !== -1 && saved.width) {
            // $set fuerza reactividad en Vue 2
            ref[0].$set(ref[0].$data.fields, fieldIndex, {
              ...ref[0].$data.fields[fieldIndex],
              width: saved.width
            })
          }
        })
        console.log('✅ Anchos restaurados con $set, tab', index)
      }, 50)
    },

    // Aplica los anchos guardados al DOM
    _applyWidthsToDom (editorEl, index) {
      if (!this.columnWidths[index] || !this.columnWidths[index].length) return
      const headers = editorEl.querySelectorAll('thead tr th')
      if (!headers.length) return

      console.log('📐 Aplicando anchos, headers encontrados:', headers.length)
      this.columnWidths[index].forEach((saved, i) => {
        if (headers[i] && saved.width && saved.width !== '0px') {
          console.log(`  th[${i}] antes: ${headers[i].style.width} → después: ${saved.width}`)
          headers[i].style.width = saved.width
          headers[i].style.minWidth = saved.width
        }
      })
    },

    // ─── Export ───────────────────────────────────────────────────
    exportAsExcel (i) {
      const format = 'xlsx'
      const exportSelectedOnly = true
      const filename = this.nameMarca + ' - ' + moment().format('YYYY-MM-DD')
      this.$refs[i][0].exportTable(format, exportSelectedOnly, filename)
    },
    exportAsCsv (i) {
      const format = 'csv'
      const exportSelectedOnly = true
      const filename = this.nameMarca + ' - ' + moment().format('YYYY-MM-DD')
      this.$refs[i][0].exportTable(format, exportSelectedOnly, filename)
    },

    // ─── Estilos de celda ─────────────────────────────────────────
    linkClass (idx) {
      if (this.tabIndex === idx) {
        return ['bg-primary', 'text-light']
      } else {
        return ['bg-light', 'text-info']
      }
    },
    mystyle (rec, col) {
      if (col.name === 'catalogo') {
        return { 'background-color': '#fbff008a' }
      } else if (col.name === 'marca') {
        return { background: '#ffb3077a' }
      } else if (col.name === 'fullname' || col.name === 'id_client') {
        return { background: '#28a7458c' }
      } else if (col.name === 'cantidad' || col.name === 'pagina' || col.name === 'comentario') {
        return { background: '#c146f078' }
      } else if (col.name === 'delivery_date') {
        return { background: '#53a9ffa1' }
      } else {
        return { 'background-color': 'white' }
      }
    },

    // ─── Carga de datos ───────────────────────────────────────────
    async loadItems (marca) {
      try {
        this.jsondata = []
        const items = {
          status: 2,
          provider_id: marca.id_provider,
          enterprise_id: this.user.enterprise_id
        }
        const response = await axiosAdelaService.post('/getOrders', items)
        if (response.status === 200) {
          this.totalRecords = response.data.totalRecords
          if (this.totalRecords > 0) {
            this.jsondata = response.data.rows
            this.$nextTick(() => {
              setTimeout(() => {
                this.attachResizeListener(this.tabIndex)
                this.restoreColumnWidths(this.tabIndex)
              }, 150)
            })
          } else {
            this.$toastedPush({
              message: `No existen mas registros para ${marca.marca}.`,
              type: 'info'
            })
            this.$router.push({ name: 'orders' })
          }
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudieron obtener las empresas intentalo mas tarde.')
      }
    },

    // ─── Cálculo de fechas ────────────────────────────────────────
    async dateCalcule (...args) {
      if (args[3].name === 'marca') {
        if (!this.optionsMarca.includes(args[0])) {
          this.optionsMarca.push(args[0])
        }
      }
      const today = moment().format('YYYY-MM-DD')
      const endWeek = moment().endOf('week').format('YYYY-MM-DD')
      let days1 = [3, 4, 5]
      let days2 = [6, 0, 1, 2]
      const nextWeek = moment(today).add(1, 'week').startOf('week').format('YYYY-MM-DD')
      let deliveryDay = ''
      let date = ''
      if (args[0] === 'ANDREA' || args[0] === 'MODA CLUB' || args[0] === 'STOP' || args[0] === 'DEVENDI' || args[0] === 'AGIL') {
        if (days1.includes(moment(today).day())) {
          deliveryDay = moment(nextWeek).add(3, 'days').format('llll')
          date = moment(nextWeek).add(3, 'days').format('YYYY-MM-DD')
        } else if (days2.includes(moment(today).day())) {
          deliveryDay = moment(nextWeek).add(5, 'days').format('llll')
          date = moment(nextWeek).add(5, 'days').format('YYYY-MM-DD')
        }
      } else {
        days1 = [0, 1, 2, 3]
        days2 = [4, 5, 6]
        if (days1.includes(moment(today).day())) {
          deliveryDay = moment(endWeek).add(6, 'days').format('llll')
          date = moment(endWeek).add(6, 'days').format('YYYY-MM-DD')
        } else if (days2.includes(moment(today).day())) {
          deliveryDay = moment(nextWeek).add(2, 'days').format('llll')
          date = moment(nextWeek).add(2, 'days').format('YYYY-MM-DD')
        }
      }
      args[2].delivery_date = deliveryDay
      args[2].date = date
    },

    // ─── Confirmación y guardado ──────────────────────────────────
    async confirmationDialog (type) {
      const reference = 'redrogo' + this.tabIndex
      const selected = this.$refs[reference][0].selectedCount
      const data = selected > 0 ? this.$refs[reference][0].getSelectedRecords() : this.jsondata[this.tabIndex].orders
      let functionName = ''
      const msg = selected > 0
        ? '<div class="text-center"><h4>Confirme que desea procesar los elementos seleccionados</h4></div>'
        : '<div class="text-center"><h4>No existen elementos seleccionados, desea procesar todos lo elementos de la tabla.</h4></div>'
      switch (type) {
        case 'buy': functionName = 'chargePurchase'; break
        case 'save': functionName = 'updateOrders'; break
        default: break
      }
      this.$dialog.confirm(msg)
        .then(async () => {
          const response = await this.verifyChangesProviders(data)
          this.save(response, functionName)
          this.save(selected === 0, functionName)
        })
        .catch((error) => {
          console.log('presiono cancelar confirmationDialog', error)
        })
    },

    async verifyChangesProviders (data) {
      return new Promise((resolve) => {
        let cont = 0
        let textX = '<div class="text-center">Esta usted seguro de cambiar de empresa a las siguientes filas: <br><div><br><ul>'
        for (let index = 0; index < data.length; index++) {
          if (data[index].id_provider !== this.id_provider) {
            cont++
            const reformattedArray = this.enterprises.find(el => el.id_provider === data[index].id_provider)
            textX += `<li> Fila # ${cont + 1} de <b><span style="color:green">${this.nameMarca}</span> a <span style="color:red">${reformattedArray.name}</span></b></li>`
          }
        }
        textX += '</ul></div></div>'
        if (cont > 0) {
          this.$dialog.confirm(textX)
            .then(() => resolve(true))
            .catch(() => resolve(false))
        } else {
          resolve(false)
        }
      })
    },

    async save (all, functionName) {
      const reference = 'redrogo' + this.tabIndex
      let data = []
      if (all) {
        data = this.jsondata[this.tabIndex].orders
      } else {
        data = this.$refs[reference][0].getSelectedRecords()
      }
      const items = {
        id_provider: this.id_provider,
        data: data,
        enterprise: this.user.enterprise_id
      }
      const response = await axiosAdelaService.post(`/${functionName}`, items)
      if (response.status === 200) {
        this.$toastedPush({
          message: 'Se actualizaron las ordenes seleccionadas.',
          type: 'success'
        })
        this.loadItems(this.$route.params)
      }
    },

    // ─── Empresas ─────────────────────────────────────────────────
    async getEnterprises () {
      try {
        const response = await axiosAdelaService.post('/getProviders', {})
        if (response.status === 200) {
          this.enterprises = response.data.rows
          response.data.rows.forEach(element => {
            this.optionsEnterprise.push(element.name)
          })
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudieron obtener las empresas, por favor intentelo mas tarde')
      }
    },

    changeEnterprise (...args) {
      const reformattedArray = this.enterprises.find(el => el.name.toUpperCase() === args[0].toUpperCase())
      args[2].provider_id = reformattedArray.id_provider
      args[2].id_provider = reformattedArray.id_provider
    },

    // ─── Eliminar ─────────────────────────────────────────────────
    async deleteOrder () {
      const reference = 'redrogo' + this.tabIndex
      const selected = this.$refs[reference][0].selectedCount
      if (selected > 0) {
        const seleccionados = this.$refs[reference][0].getSelectedRecords()
        seleccionados.forEach(async el => {
          await this.borrarElemento(el.id_order)
        })
        await this.loadItems(this.$route.params)
      } else {
        this.$toastedPush({
          message: 'Por favor seleccione al menos un elemento para ser eliminado.',
          type: 'error'
        })
      }
    },

    async borrarElemento (order) {
      try {
        const response = await axiosAdelaService.post('/deleteOrder', { order_id: order })
        if (response.status === 200) {
          this.$toastedPush({
            message: 'Se elimino la orden correctamente.',
            type: 'success'
          })
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudo agregar la orden, intentalo mas tarde')
      }
    },

    // ─── Faltante ─────────────────────────────────────────────────
    async agregarFaltante () {
      try {
        const reference = 'redrogo' + this.tabIndex
        const selected = this.$refs[reference][0].selectedCount
        if (selected > 0) {
          const seleccionados = this.$refs[reference][0].getSelectedRecords()
          const response = await axiosAdelaService.post('/updateOrderFaltante', { data: seleccionados })
          if (response.status === 200) {
            await this.loadItems(this.$route.params)
            this.$toastedPush({
              message: 'Ordenes marcadas como faltantes correctamente...',
              type: 'success'
            })
          }
        } else {
          this.$toastedPush({
            message: 'Por favor seleccione al menos un elemento para ser eliminado.',
            type: 'error'
          })
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudieron obtener los clientes, por favor intentelo mas tarde')
      }
    },

    async updateOpenText (...args) {
      args[2].campo_muerto = args[0]
      await this.save(true, 'updateOrders')
    }
  },

  async mounted () {
    if (this.$route.params.marca === undefined) {
      this.$router.push({ name: 'orders' })
    }
    await this.getEnterprises()
    await this.loadItems(this.$route.params)
    this.nameMarca = this.$route.params.marca
    this.id_provider = this.$route.params.id_provider
  }
}
</script>

<style>
.btnGenerateBuy {
  display: inline-block;
}
.vue-excel-editor .systable th {
  overflow: hidden;
  white-space: nowrap;
}
</style>
